import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Elements from './Elements';
import Filters from './Filters';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1
  }
}));

const PaymentsGrid = () => {
  const classes = useStyles();
  const [filters, setFilters] = useState<any>({});

  const updateFilters = (filters: any) => {
    setFilters(filters);
  };

  return (
    <div className={classes.container}>
      <Filters onFiltersUpdated={updateFilters}></Filters>
      <Elements filters={filters}></Elements>
    </div>
  );
}

export default PaymentsGrid;